import { createContext } from 'react';

import type { ModalContextType } from '@/shared/contexts';

export const ModalContext = createContext<ModalContextType>(
  {} as ModalContextType,
);
